module.exports = __webpack_public_path__ + "img/s2P27.3a704c94.png";